/**
 * 项目默认配置项
 *
 */
export default {
  permission: {
    router: false, //是否开启路由权限验证
    action: true //是否开启功能权限验证
  }
};
